export default __webpack_public_path__ + "static/media/ted3.08108848.jpg";